import './NotificationsMFE.scss';
import React, { useEffect } from 'react';
import {getPershingJWT, resetBrokerageMFE} from 'services/Rest';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  getBrokerageMFELogin,
  getBrokerageMFEState,
} from 'state/brokerage/BrokerageSelectors';
import Store from 'state/Store';
import {receivedBrokerageLogin, updateBrokerageMFEState} from 'state/brokerage/BrokerageActions';
import { getLdapId } from 'state/customer/CustomerSelectors';
import lockIcon from 'assets/icons/hex-lock-icon.svg';
import PageLoadingSpinner from 'components/layouts/Navigation/PageLoadingSpinner';
import {MFE_STATE} from "support/BrokerageMFEUtils";

const NotificationsBrokerageMFE = ({ MFEState, mfeLoggedIn, ldapId }) => {
  useEffect(() => {
    return () => {
      resetBrokerageMFE();
    }
  }, []);

  const handleEvents = (event) => {
    if (event.msgid === 'PERMFE003') {
      // successful login
      Store.dispatch(receivedBrokerageLogin(true));
    }
    // Renew token event
    if (event.msgid === 'PERMFE007') {
      getPershingJWT(true, ldapId);
    }
    // Login Error
    if (event.msgid === 'PERMFE004') {
      Store.dispatch(updateBrokerageMFEState(MFE_STATE.ERROR));
    }
    //MFE Loading event
    if (event.msgid === 'PERMFE011') {
      if (event.text.includes('Loaded Module @pershing/nxi-ng-account')) {
        Store.dispatch(updateBrokerageMFEState(MFE_STATE.LOADED));
      }
    }
  }

  useEffect(() => {
    if (window && window.pershingMFEHelper && ldapId) {
      window.pershingMFEHelper.getPershingMFEEvents(handleEvents);
      if (mfeLoggedIn) {
        // Load the required MFE Modules form pershing
        window.pershingMFEHelper.loadModules(["nxi-ng-account"]);
      } else {
        //Get the JWT token from the Pershing API
        getPershingJWT(false, ldapId);
      }
    }
  }, [mfeLoggedIn, ldapId]);

  const renderPage = () => {
    if (MFEState === MFE_STATE.LOADING) {
      return <PageLoadingSpinner name="Alerts & Notifications" />;
    }
    return (
      <div className="beacon-on-darker">
        <div className="notification-mfe-wrapper">
          <div className="per-mfe-ns brokerageNotificationWrapper blocked_data">
            <div>
              <notification-setup-app
                is-watchlist-enabled="false"
                is-price-volume-enabled="false"
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  return MFEState === MFE_STATE.ERROR ? (
    <div className="dividends-and-capital-gains-brokerage-refresh-container-v2">
      <div className="dividends-and-capital-gains-lock-icon-container-v2">
        <img src={lockIcon} alt="lock icon" />
        <div>
          <p>
            <strong>Data unable to load</strong>
          </p>
          <p className="dividends-and-capital-gain-paragraph">
            Brokerage account activity alerts could not be retrieved.
          </p>
        </div>
      </div>
    </div>
  ) : (
    renderPage()
  );
};

const mapStateToProps = (state) => ({
  MFEState: getBrokerageMFEState(state),
  mfeLoggedIn: getBrokerageMFELogin(state),
  ldapId: getLdapId(state)
});
export default compose(connect(mapStateToProps))(NotificationsBrokerageMFE);
